import React from "react";
import { useTranslation } from "react-i18next";


import './fastInteraction.scss'


function FastInteraction() {
    const { t } = useTranslation()

    return (
        <div className="container-fastinteraction">
            <div className="texts-fastinteraction">
                <div>
                    <h1>{t("rapid_dashboard.fast_interaction.title")}</h1>
                    <p>{t("rapid_dashboard.fast_interaction.section_text")}</p>
                </div>
                <div>
                    <h1>{t("rapid_dashboard.custom_dashboards.title")}</h1>
                    <p>{t("rapid_dashboard.custom_dashboards.section_text")}</p>
                </div>
            </div>
        </div>
    )
}

export default FastInteraction